import { stringify } from 'qs';
import request from '@/utils/request';
import { loginOrg, loginUser, loginCompany } from '@/utils/LoginContext';

export async function labelsummary(payload){
    return request(`/iwms-wms/wms/sowingpick/labelsummary`,{
        method:'POST',
        body: payload
    })
}
